import { Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";

const AcxWideTooltip = styled(Tooltip)({
    maxWidth: "100%",
});

export default AcxWideTooltip;
